<template>
  <div class="nomination-card">
    <div class="nomination-card__info" :class="{'nomination-card__info--personal': type === 'personal'}">
      <div class="nomination-card__cover">
        <img :src="image" />
      </div>
      <div :style="type === 'personal' ? 'margin-right: 20px;' : ''">
        <div class="nomination-card__nomination" v-html="nominationText"></div>
        <div class="nomination-card__title" v-html="title"></div>
      </div>
      <div class="nomination-card__actions" v-if="type === 'general'">
        <Button
          variant="secondary"
          size="sm"
          icon-left="read"
          :text="rules.text"
          mobile
          @click="rules.action ? rules.action() : null"
        ></Button>
        <Button
          variant="secondary"
          size="sm"
          icon-left="trophy"
          :text="prizes.text"
          mobile
          @click="prizes.action ? prizes.action() : null"
        ></Button>
      </div>
    </div>
    <div
      class="nomination-card__actions nomination-card__actions--personal"
      v-if="type === 'personal' && state !== 'in-progress' && state !== 'result'"
    >
      <Button
        variant="secondary"
        size="sm"
        icon-left="read"
        :text="rules.text"
        mobile
        @click="rules.action ? rules.action() : null"
      ></Button>
      <Button
        variant="secondary"
        size="sm"
        icon-left="trophy"
        :text="prizes.text"
        mobile
        @click="prizes.action ? prizes.action() : null"
      ></Button>
    </div>
    <div
      class="nomination-card__rating"
      :class="{'nomination-card__rating--personal': type === 'personal'}"
      v-if="state === 'in-progress'"
      @click.stop="$emit('show-details')"
    >
      <div class="nomination-card__rating-title">
        <div class="nomination-card__rating-divider"></div>
        <div class="nomination-card__rating-text" v-html="type === 'general' ? ratingText.general : ratingText.personal"></div>
        <div class="nomination-card__rating-divider"></div>
      </div>
      <div class="nomination-card__rating-table">
        <table>
          <tr
            v-for="(item, i) in fillTable()"
            :key="i"
            class="nomination-card__rating-item"
            :class="{'rating-item--active': item.current === true}"
          >
            <td class="rating-item__number" v-if="type === 'general'">{{ i + 1 }}</td>
            <td class="rating-item__number" v-else-if="item.change === 'up'">{{ item.number }}<span class="number--up">&#8239;&#8593;</span></td>
            <td class="rating-item__number" v-else-if="item.change === 'down'">{{ item.number }}<span class="number--down">&#8239;&#8595;</span></td>
            <td class="rating-item__number" v-else>{{ item.number }}</td>
            <td class="rating-item__name">{{ item.name }}</td>
            <td class="rating-item__value">
              <div>
                {{ item.value }}<img v-if="item.value !== '-'" :src="pointImage" width="18" height="18"/>
              </div>
            </td>
          </tr>
        </table>
      </div>
    </div>
    <div
      class="nomination-card__locked"
      v-if="state === 'locked'"
    >
      <div class="locked__message">
        <span v-html="lockedText.text"></span><br>
        <span v-html="lockedText.link" @click.stop="$emit('locked-click')" class="locked__link"></span>
      </div>
    </div>
    <div
      class="nomination-card__select"
      v-if="state === 'select-task'"
    >
      <div class="nomination-card__rating-title">
        <div class="nomination-card__rating-divider"></div>
        <div class="nomination-card__rating-text" v-html="selectTaskText"></div>
        <div class="nomination-card__rating-divider"></div>
      </div>
      <div class="nomination-card__task">
        <div
          v-for="(task, i) in tasks"
          :key="i"
          class="nomination-card__task-item"
          @click.stop="$emit('task-click', i)"
        >
          <div class="task-item__image">
            <img :src="task.img || taskCover" />
          </div>
          <div class="task-item__title">{{ task.title }}</div>
        </div>
      </div>
    </div>
    <div
      class="nomination-card__result"
      :class="{'nomination-card__result--personal': type === 'personal'}"
      v-if="state === 'result'"
    >
      <div class="nomination-card__rating-title">
        <div class="nomination-card__rating-divider"></div>
        <div class="nomination-card__rating-text" v-html="resultText.rating"></div>
        <div class="nomination-card__rating-divider"></div>
      </div>
      <table width="100%" @click.stop="$emit('show-details')">
        <tr
          class="nomination-card__rating-item nomination-card__rating-item--current"
        >
          <td class="rating-item__number">{{ resultValues.rating.number }}</td>
          <td class="rating-item__name">{{ resultValues.rating.name }}</td>
          <td class="rating-item__value">
            <div>
              {{ resultValues.rating.value }}<img :src="pointImage" width="18" height="18"/>
            </div>
          </td>
        </tr>
      </table>
      <div v-if="resultValues.reward" class="nomination-card__rating-title" style="margin-top: 1.25rem;">
        <div class="nomination-card__rating-divider"></div>
        <div class="nomination-card__rating-text" v-html="resultText.reward"></div>
        <div class="nomination-card__rating-divider"></div>
      </div>
      <div v-if="resultValues.reward" class="nomination-card__task">
        <div
          class="nomination-card__task-item"
          @click.stop="$emit('reward-click')"
        >
          <div class="task-item__image">
            <img :src="resultValues.reward.img || taskCover" />
          </div>
          <div class="task-item__title">{{ resultValues.reward.title }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Button from '@rr-component-library/button/src/main';
import Point from '../assets/img/point.svg';
import TaskCover from '../assets/img/task-cover.png';

export default {
  name: 'NominationCard',
  designVersion: '1.1.0',
  components: {
    Button,
  },
  props: {
    /**
     * Ссылка на верхнее изображение
     */
    image: {
      type: String,
    },
    /**
     * Тип номинации<br>
     * `'general'` - общий<br>
     * `'personal'` - личный
     */
    type: {
      type: String,
      default: 'general',
      validator(value) {
        return ['', 'general', 'personal'].indexOf(value) !== -1;
      },
    },
    /**
     * Состояние<br>
     * `'locked'` - не выполненено условие для участия<br>
     * `'select-task'` - выбор задачи<br>
     * `'in-progress'` - уже участвуем в номинации<br>
     * `'result'` - отображение результата
     */
    state: {
      type: String,
      default: 'in-progress',
      validator(value) {
        return ['', 'locked', 'select-task', 'in-progress', 'result'].indexOf(value) !== -1;
      },
    },
    /**
     * Текст надписи номинации
     */
    nominationText: {
      type: String,
    },
    /**
     * Текст заголовка
     */
    title: {
      type: String,
    },
    /**
     * Свойства кнопки с правилами<br>
     * `{ text: 'Правила', action: someFunc() { ... } }`<br>
     * поле `text` - текст надписи на кнопке<br>
     * поле `action` - функция, выполняемая при нажатии на кнопку
     */
    rules: {
      type: Object,
    },
    /**
     * Свойства кнопки с наградами<br>
     * `{ text: 'Награды', action: someFunc() { ... } }`<br>
     * поле `text` - текст надписи на кнопке<br>
     * поле `action` - функция, выполняемая при нажатии на кнопку
     */
    prizes: {
      type: Object,
    },
    /**
     * Текст надписи рейтинга<br>
     * `{ general: '', personal: '' }`<br>
     * поле `general` - текст надписи на общей номинации<br>
     * поле `personal` - текст надписи для персональной номинации
     */
    ratingText: {
      type: Object,
    },
    /**
     * Текст надписи для невыполненного условия<br>
     * `{ text: '', link: '' }`<br>
     * поле `text` - текст сообщения<br>
     * поле `link` - текст ссылки
     */
    lockedText: {
      type: Object,
    },
    /**
     * Текст заголовка для состояния 'select-task'
     */
    selectTaskText: {
      type: String,
    },
    /**
     * Текст заголовков для состояния 'result'<br>
     * `{ rating: '', reward: '' }`<br>
     * поле `rating` - текст заголовка рейтинга<br>
     * поле `reward` - текст заголовка награды
     */
    resultText: {
      type: Object,
    },
    /**
     * Массив значений для рейтинга<br>
     * `[ { name: 'Сопарева Хельга', value: '318', current: true, change: 'up' }, ... ]`<br>
     * поле `name` - имя и фамилия<br>
     * поле `value` - количество очков/баллов<br>
     * поле `current` - признак личного результата (необязательно)<br>
     * поле `value` - признак повышения ('up') / понижения ('down') личного результата (необязательно)
     */
    values: {
      type: Array,
    },
    /**
     * Массив значений для списка задач<br>
     * `[ { img: '', title: '318' }, ... ]`<br>
     * поле `img` - путь к файлу изображения<br>
     * поле `title` - текст названия задачи<br>
     */
    tasks: {
      type: Array,
    },
    /**
     * Результаты для состояния 'result'<br>
     * `{ rating: {...}, reward: {...} }`<br>
     * поле `rating` - данные рейтинга<br>
     * поле `reward` - данные награды
     */
    resultValues: {
      type: Object,
    },
    /**
    Картинка рядом с очками
     */
    pointImage: {
      type: String,
      default: Point
    },
  },
  data() {
    return {
      taskCover: TaskCover,
    };
  },
  methods: {
    fillTable() {
      const emptyRow = { name: '-', value: '-' };
      const newValues = [...this.values];
      newValues.push(...Array(3 - newValues.length).fill({ ...emptyRow }));
      return newValues;
    }
  }
};
</script>

<style lang="scss" scoped>
  @import "./NominationCard";
</style>
